import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = '/api/';
import { Container, Typography, TextField, Button, Table, TableBody, TableCell, TableHead, TableRow, IconButton, Paper } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

const VestidoNoiva = () => {
  const [vestidos, setVestidos] = useState([]);
  const [modelo, setModelo] = useState('');
  const [valor, setValor] = useState('');
  const [loja, setLoja] = useState('');
  const [contato, setContato] = useState('');
  const [editId, setEditId] = useState(null);

  const fetchVestidos = async () => {
    const res = await axios.get(`${API_URL}vestido_noiva`);
    setVestidos(res.data);
  };

  useEffect(() => {
    fetchVestidos();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (editId) {
      await axios.put(`${API_URL}vestido_noiva/${editId}`, { modelo, valor, loja, contato });
    } else {
      await axios.post(`${API_URL}vestido_noiva`, { modelo, valor, loja, contato });
    }
    setModelo('');
    setValor('');
    setLoja('');
    setContato('');
    setEditId(null);
    fetchVestidos();
  };

  const handleEdit = (vestido) => {
    setModelo(vestido.modelo);
    setValor(vestido.valor);
    setLoja(vestido.loja);
    setContato(vestido.contato);
    setEditId(vestido.id);
  };

  const handleDelete = async (id) => {
    await axios.delete(`/api/vestido_noiva/${id}`);
    fetchVestidos();
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>Vestido da Noiva</Typography>
      <Paper sx={{ p: 2, mb: 2 }}>
        <form onSubmit={handleSubmit} style={{ display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'center' }}>
          <TextField
            label="Modelo"
            value={modelo}
            onChange={e => setModelo(e.target.value)}
            required
          />
          <TextField
            label="Valor"
            type="number"
            value={valor}
            onChange={e => setValor(e.target.value)}
            required
          />
          <TextField
            label="Loja"
            value={loja}
            onChange={e => setLoja(e.target.value)}
          />
          <TextField
            label="Contato"
            value={contato}
            onChange={e => setContato(e.target.value)}
          />
          <Button type="submit" variant="contained" color="primary">
            {editId ? 'Salvar' : 'Adicionar'}
          </Button>
          {editId && (
            <Button variant="outlined" color="secondary" onClick={() => { setEditId(null); setModelo(''); setValor(''); setLoja(''); setContato(''); }}>
              Cancelar
            </Button>
          )}
        </form>
      </Paper>
      <Table component={Paper}>
        <TableHead>
          <TableRow>
            <TableCell>Modelo</TableCell>
            <TableCell>Valor</TableCell>
            <TableCell>Loja</TableCell>
            <TableCell>Contato</TableCell>
            <TableCell>Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {vestidos.map(vestido => (
            <TableRow key={vestido.id}>
              <TableCell>{vestido.modelo}</TableCell>
              <TableCell>{vestido.valor}</TableCell>
              <TableCell>{vestido.loja}</TableCell>
              <TableCell>{vestido.contato}</TableCell>
              <TableCell>
                <IconButton onClick={() => handleEdit(vestido)}><EditIcon /></IconButton>
                <IconButton onClick={() => handleDelete(vestido.id)} color="error"><DeleteIcon /></IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Container>
  );
};

export default VestidoNoiva;
